var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8524cb2fd7cac8ce751f8bd877cd1b354f800fcb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rechargesms@rechargeapps"]={id:"8524cb2fd7cac8ce751f8bd877cd1b354f800fcb"};
      